import * as React from 'react';
import styled, { css } from 'styled-components';
import { colors, spacing } from 'ui/theme';

/**
 * I'm hoping that these can be base grid definitions that we can reuse across index pages. Because
 * each index page will have its own layout contraints, we expose a way to inject that value directly
 */

const baseGridRules = css`
  background: ${colors.white};
  padding: ${spacing.base} ${spacing.layoutLRPadding};

  &:nth-child(even) {
    background: ${colors.grey1};
  }
`;

export const StyledGridRow = styled.div`
  ${baseGridRules}
  column-gap: ${spacing.base};
  display: grid;
  grid-template-columns: ${({ gridLayout }: { gridLayout: string }) =>
    gridLayout}; /** this allows us to inject layout directly at point of use */
`;

const StyledHeaderRow = styled(StyledGridRow)`
  ${baseGridRules}
  border-top: ${spacing.single} solid ${colors.grey15};
  border-bottom: solid ${spacing.single} ${colors.grey15};
  padding-top: ${spacing.half};
  padding-bottom: ${spacing.half};
`;

export interface RowProps {
  children?: React.ReactNode;
  gridLayout: string;
  showLocales?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const GridRow = ({ children, gridLayout, ...props }: RowProps) => (
  <StyledGridRow data-test="grid-row" gridLayout={gridLayout} role="row" {...props}>
    {children}
  </StyledGridRow>
);

export const HeaderGridRow = ({ children, gridLayout, ...props }: RowProps) => (
  <StyledHeaderRow data-test="header-grid-row" gridLayout={gridLayout} role="row" {...props}>
    {children}
  </StyledHeaderRow>
);

const StyledFullWidthGridRow = styled.div`
  ${baseGridRules}
  grid-column-start: 1; /** by not including a span definition this forces the grid to stretch fully AFAIK */
`;

export interface FullRowProps {
  children?: React.ReactNode;
}
export const FullWidthGridRow = (props: FullRowProps) => (
  <StyledFullWidthGridRow data-test="full-width-grid-row" {...props} />
);
